export const tokens = {
  colors: {
    primary: {
      black: '#000000',
      white: '#FFFFFF',
      neutral: {
        50: '#F9FAFB',
        100: '#F3F4F6',
        200: '#E5E7EB',
        300: '#D2D5DA',
        400: '#9CA3AF',
        500: '#6D7280',
        600: '#4B5563',
        700: '#374151',
        800: '#1F2937',
        900: '#111827',
        1000: '#282828',
        1010: '#1a1a1f',
        1020: '#1D1919',
        1030: '#0c0c0c'
      }
    },
    supporting: {
      red: {
        500: '#EF4444',
        600: '#DC2626'
      },
      green: {
        500: '#22C55E',
        600: '#16A34A'
      },
      yellow: {
        500: '#EAB308',
        600: '#CA8A04'
      }
    },
    // Drupi Social brand gradient: blue → purple
    brand: {
      blue: 'rgb(51, 63, 131)',
      purple: 'rgb(154, 33, 140)',
      gradient: 'linear-gradient(90deg, rgb(51, 63, 131) 0%, rgb(154, 33, 140) 100%)'
    },
    // Legacy alias — remove once all pages migrated
    luzu: {
      orange: 'rgb(51, 63, 131)',
      magenta: 'rgb(154, 33, 140)',
      gradient: 'linear-gradient(90deg, rgb(51, 63, 131) 0%, rgb(154, 33, 140) 100%)'
    }
  }
};
